import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../../../services/auth/authService';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Guard against double execution in StrictMode
        const isProcessing = sessionStorage.getItem('oauth_processing');
        if (isProcessing === 'true') {
          console.log('OAuth callback already processing, skipping duplicate execution');
          return;
        }
        sessionStorage.setItem('oauth_processing', 'true');

        // Extract code from URL
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');
        const error = params.get('error');

        console.log('OAuth callback received');

        if (error) {
          sessionStorage.removeItem('oauth_processing');
          throw new Error(`OAuth error: ${error}`);
        }

        if (!code) {
          sessionStorage.removeItem('oauth_processing');
          throw new Error('No authorization code received');
        }

        // Verify state
        const storedState = sessionStorage.getItem('oauth_state');
        if (state !== storedState) {
          throw new Error('State mismatch - potential CSRF attack');
        }

        // Exchange code for tokens (frontend does this, not backend)
        const { accessToken, refreshToken, idToken, userId } =
          await authService.exchangeCodeForToken(code);

        // Store tokens in sessionStorage
        sessionStorage.setItem('accessToken', accessToken);
        sessionStorage.setItem('refreshToken', refreshToken);
        sessionStorage.setItem('idToken', idToken);
        sessionStorage.setItem('userId', userId);

        // Clean up sessionStorage
        sessionStorage.removeItem('oauth_state');
        sessionStorage.removeItem('oauth_code_verifier');
        sessionStorage.removeItem('oauth_processing');

        // Clean up URL
        window.history.replaceState({}, document.title, '/');

        // Redirect to saved post-login path or requestor
        const postLoginRedirect = sessionStorage.getItem('postLoginRedirect');
        const redirectPath = postLoginRedirect || '/requestor';
        sessionStorage.removeItem('postLoginRedirect');
        navigate(redirectPath, { replace: true });
      } catch (error) {
        console.error('Callback handling failed:', error);
        sessionStorage.removeItem('oauth_processing');
        navigate('/login', { replace: true });
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h2>Processing authentication...</h2>
      <p>Redirecting you to the dashboard...</p>
    </div>
  );
};

export default AuthCallback;
